export default __webpack_public_path__ + "static/media/twitter.4f6bcf48.svg";